<template>
  <div style="background-color: #F8F9FB;text-align: center;">
    <div class="succBox">
      <img src="../../../../assets/images/crm/succ.png" alt="" />
      <h3>邀请成功</h3>
      <p>欢迎您登录杰宜斯云服务进行操作！</p>
      <li>{{ text }}<i @click="copy" class="iconfont icon-fuzhi1"> </i></li>
      <span v-show="show">复制成功</span>
    </div>
  </div>
</template>
<script>
import './style.css';
export default {
  data() {
    return {
      text: 'http://crm.jeesit.com/',
      show: false,
    };
  },
  mounted() {},
  methods: {
    copy() {
      //复制功能
      let that = this;
      this.$copyText(this.text).then(
        function(e) {
          that.show = true;
        },
        function(e) {
          //复制失败
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/invitation/succ/index.vue